// ============================================
// DARIJA BUDDY - Refactored Entry Point
// ============================================
// This file now serves as a clean entry point that re-exports
// the refactored components from /components/buddy/

import { DarijaBuddyBot, DarijaBuddyAdmin } from './components/buddy';

// Re-export with original names for backward compatibility
const DarijaBuddy = DarijaBuddyBot;

export { DarijaBuddy, DarijaBuddyAdmin };
